import React from 'react';
import type { DocRecord, DocumentAccess } from '../../lib/supabase-service';

export const DocumentViewer = ({ document, access, onClose }: {
    document: DocRecord; access: DocumentAccess; onClose: () => void;
}) => <div role="dialog" aria-modal="true" aria-label={document.title} className="fixed inset-0 z-50 bg-slate-950/95 flex flex-col p-6 gap-4 text-white">
    <div className="flex justify-between"><h2>{document.title}</h2><button onClick={onClose}>Cerrar</button></div>
    {access.url && access.mime_type === 'application/pdf'
        ? <iframe title={document.title} src={access.url} className="w-full flex-1 bg-white" />
        : access.source_type === 'INTERNAL'
            ? <pre className="overflow-auto whitespace-pre-wrap">{JSON.stringify(access.content, null, 2)}</pre>
            : access.url
                ? <a href={access.url} target="_blank" rel="noopener noreferrer" className="bg-indigo-600 p-4 rounded-xl self-start">{access.source_type === 'EXTERNAL_LINK' ? 'Abrir enlace externo' : 'Descargar documento'}</a>
                : <p>Sin contenido disponible.</p>}
</div>;
